// Thin wrapper around PatternBuilder.js so that components never import it
// directly. All PDF generation goes through this service.
//
// Both functions return a Promise that resolves to { url, blob } —
// url is a blob URL for previewing/opening the PDF,
// blob is the raw PDF Blob used for uploading to Firebase Storage.

import BuildPattern from '../utils/PatternBuilder';

// Generates a full, password-protected pattern PDF for a subscribed user.
export const generatePattern = (options) =>
	BuildPattern({ ...options, subscribed: true });

// Generates a sample (watermarked/partial) pattern PDF for preview or free access.
export const generateSamplePattern = (options) =>
	BuildPattern({ ...options, subscribed: false });
